<template>
  <!-- Toasts -->
  <div class="toast-container">
    <transition-group name="toast">
      <div
        v-for="toast in state.toasts"
        :key="toast.id"
        :class="['toast', `toast--${toast.type}`]"
      >
        <span class="toast-icon">
          {{ toast.type === 'error' ? '✕' : toast.type === 'success' ? '✓' : 'ℹ' }}
        </span>
        <span class="toast-message">{{ toast.message }}</span>
      </div>
    </transition-group>
  </div>

  <!-- Confirm dialogs -->
  <div
    v-if="state.confirms.length > 0"
    class="confirm-overlay"
    @click.self="resolve(false)"
  >
    <div class="confirm-card">
      <div class="confirm-message">{{ state.confirms[0].message }}</div>
      <div class="confirm-actions">
        <button class="btn btn-ghost" type="button" @click="resolve(false)">Cancelar</button>
        <button class="btn btn-danger" type="button" @click="resolve(true)">Confirmar</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { uiStore } from '@/store/ui'

export default defineComponent({
  name: 'AppDialogs',
  setup() {
    const { state } = uiStore

    const resolve = (value: boolean) => {
      if (state.confirms.length > 0) {
        uiStore._resolveConfirm(state.confirms[0].id, value)
      }
    }

    return { state, resolve }
  }
})
</script>

<style scoped lang="scss">
.toast-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
}

.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  font-size: 13px;
  font-weight: 500;
  max-width: 360px;
  pointer-events: all;
  border: 1px solid transparent;

  &--info {
    background: var(--surface);
    color: var(--ink);
    border-color: var(--border-strong);
  }

  &--success {
    background: #f0faf0;
    color: #1a5c1a;
    border-color: #b3ddb3;
  }

  &--error {
    background: #fdf3f3;
    color: #7a1c1c;
    border-color: #f0b3b3;
  }
}

.toast-icon {
  font-size: 14px;
  flex-shrink: 0;
  font-weight: 700;
}

.toast-message {
  line-height: 1.4;
}

/* Transition */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.22s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(16px);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(16px);
}

/* Confirm modal */
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: grid;
  place-items: center;
  z-index: 9998;
}

.confirm-card {
  background: var(--surface);
  color: var(--ink);
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-strong);
  padding: 24px 28px;
  box-shadow: var(--shadow-lg);
  min-width: min(480px, calc(100vw - 32px));
  display: grid;
  gap: 20px;
}

.confirm-message {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
  color: var(--ink);
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
